export default (usr, isEdit, isMaster) => {
  const {user, name, password, passwordRepeat, level, company} = usr;

  const sanitized = {
    user: user && user.trim(),
    name: name && name.trim(),
    password: password && password.trim(),
    passwordRepeat: passwordRepeat && passwordRepeat.trim(),
    level: level && level.trim(),
    company: company && company.trim(),
  };

  const mandatoryFields = ['user', 'name'];

  if (isMaster) {
    mandatoryFields.push('company');
  }

  // if (!isEdit) {
  //   mandatoryFields.push('password');
  //   mandatoryFields.push('passwordRepeat');
  // }

  const err = {};

  mandatoryFields.forEach((field) => {
    if (!sanitized[field]) {
      err[field] = `${field} is mandatory.`;
    }
  });

  if (Object.keys(err).length) return err;

  if (sanitized.user.length < 5 || sanitized.length > 50) {
    err.user = 'user should have between 5 and 50 characters.';
  }

  if (sanitized.name.length < 5 || sanitized.name.length > 50) {
    err.name = 'name should have between 5 and 50 characters.';
  }

  if ((sanitized.password || sanitized.passwordRepeat)) {
    if ((sanitized.password !== sanitized.passwordRepeat)) {
      err.passwordRepeat = 'The password fields doesn\'t match.';
    }

    if (sanitized.password.length < 6 || sanitized.password.length > 15) {
      err.password = 'password should have between 6 and 15 characters.';
    }
  }

  return err;
};
